export default __webpack_public_path__ + "static/media/iva_l.8c356500.jpg";